import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

export default function PendingGetHelp() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let user = "117744";
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState(0);

  const [select, setSelect] = useState("2");
  const [position, setPosition] = useState("0");

  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");
  const [TotalId, setTotalId] = useState(0);
  const [TotalAmount, setTotalAmount] = useState(0);
  const [lvl, setlvl] = useState(0);

  let arrayLeft = [];
  //   let value = 2
  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/Adminreport",
        {
          loginid: userId,
          uid: search,
          report: "GetHelp",
          fdate: formdate,
          tdate: todate,
          status: 1,
          level: lvl,
          Position: position,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("Direct team", responceRight?.data?.data);
      //console.log("Direct team Output", responceRight?.data?.dataOutput);
      setTotalId(responceRight?.data?.data[0][0]?.totalrecord);
      setTotalAmount(responceRight?.data?.dataOutput?.totalamount);
      responceRight = responceRight?.data?.data?.[0];
      setleftreferralApi([]);

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          id: item?.id,
          uid: item?.uid,
          fromid: item?.fromid,
          lvl: item?.lvl,
          Link_Amount: item?.Link_Amount,
          Ticketno: item?.Ticketno,
          ed: item?.ed,
          remark: item?.remark,
          Link_type: item?.Link_type,
          paid_status: item?.RowNumber,
          pd: item?.pd,
          approve_status: item?.approve_status,
          ad: item?.ad,
          utrno: item?.utrno,
          bank_name: item?.bank_name,
          branch: item?.branch,
          ifsc: item?.ifsc,
          holder: item?.holder,
          accountnumber: item?.accountnumber,
          accountaddress: item?.accountaddress,
          paidst: item?.paidst,
          sidapprovest: item?.sidapprovest,
          name: item?.name,
          Mobile: item?.Mobile,
          gpay: item?.gpay,
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "uid" },
      { Header: "From Id", accessor: "fromid" },
      { Header: "Level", accessor: "lvl" },
      { Header: "Amount", accessor: "Link_Amount" },
      { Header: "Ticket No.", accessor: "Ticketno" },
      { Header: "Date", accessor: "ed" },
      { Header: "Remark", accessor: "remark" },
      { Header: "Link Type", accessor: "Link_type" },
      { Header: "Paid Status", accessor: "paidst" },
      { Header: "Paid Date", accessor: "pd" },
      { Header: "Approve Status", accessor: "sidapprovest" },
      { Header: "Approve Date", accessor: "ad" },
      { Header: "UTR No.", accessor: "utrno" },
      { Header: "Bank Name", accessor: "bank_name" },
      { Header: "Branch Name", accessor: "branch" },
      { Header: "IFSC Code", accessor: "ifsc" },
      { Header: "Holder", accessor: "holder" },
      { Header: "Account No.", accessor: "accountnumber" },
      { Header: "UPI No.", accessor: "gpay" },
      { Header: "Name", accessor: "name" },
      { Header: "Mobile No", accessor: "Mobile" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Pending Get Help Report</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="userid"
                        ng-model="p.userid"
                        class="form-control in-ip-1"
                        placeholder="Enter User Id"
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                    {/* <div class="col-md-2">
                      <select
                        class="form-control in-ip-1"
                        onChange={(e) => setSelect(e.target.value)}
                        id="SelectStatus"
                        name="SelectStatus"
                      >
                        <option value="">Select Status</option>
                        <option value="2">All Status</option>
                        <option value="1">Active</option>
                        <option value="0">In-Active</option>
                      </select>
                    </div> */}
                    <div class="col-md-2">
                      <select
                        class="form-control in-ip-1"
                        id="SelectLevel"
                        onChange={(e) => setlvl(e.target.value)}
                        name="SelectLevel"
                      >
                        <option value="0">All Amount</option>
                        <option value="1">300</option>
                        <option value="2">400</option>
                        <option value="3">800</option>
                        <option value="4">1600</option>
                        <option value="5">3200</option>
                        <option value="6">6400</option>
                        <option value="7">12800</option>
                        <option value="8">25600</option>
                      </select>
                    </div>
                    {/* <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setFromdate(new Date(e.target.value))}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setTodate(e.target.value)}
                        id="todate"
                        name="todate"
                        type="date"
                      />
                    </div> */}

                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => referral_API()}
                        class="btn btn-lg btn-primary"
                        value="Search"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <h4>
                      <span>
                        Total Id: {TotalId}
                        {/* / Total Amount: {TotalAmount} */}
                      </span>
                    </h4>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
